import script from "./ScreenVideoElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScreenVideoElement.vue?vue&type=script&lang=ts&setup=true"

import "./ScreenVideoElement.vue?vue&type=style&index=0&id=76bf5b3f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76bf5b3f"]])

export default __exports__